import { Endpoint } from "../config";

export type RoleEndpointType = "roles" | "roleWithoutSlash" | "roleSelect";

export const roleEndpoints: Record<RoleEndpointType, Endpoint> = {
  roles: {
    url: "roles/",
  },
  roleWithoutSlash: {
    url: "roles",
  },
  roleSelect: {
    url: "role-list/",
  },
};
